import { useEffect, useState } from "react";
import api from "@/lib/api";
import TeaserSlot from "@/components/TeaserSlot";

export default function Community() {
    const [stories, setStories] = useState([]);
    useEffect(() => { api.get("/community/stories").then((r) => setStories(r.data)); }, []);
    return (
        <main data-testid="community-page" className="pt-32 pb-32 min-h-screen">
            <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
                <p className="eyebrow">Community</p>
                <h1 className="font-display text-6xl md:text-8xl mt-4 max-w-4xl">Stories from the <em className="text-[color:var(--gold)]">table</em>.</h1>
                <p className="mt-8 max-w-2xl text-[color:var(--cream-muted)] text-lg">Essays, portraits, and dispatches from the women who make Mrs.Black(In)Love what it is.</p>
            </section>
            <section className="mx-auto max-w-[1600px] px-6 lg:px-12 mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
                {stories.map((s, i) => (
                    <article key={s.id} className="zoom-parent group" data-testid={`story-card-${i}`}>
                        <div className="overflow-hidden">
                            <img src={s.image} alt={s.title} className="h-[440px] w-full object-cover" />
                        </div>
                        <p className="mt-6 eyebrow">{s.tag}</p>
                        <h3 className="font-serif text-3xl mt-2 group-hover:text-[color:var(--gold)] transition-colors duration-300">{s.title}</h3>
                        <p className="mt-3 text-[color:var(--cream-muted)] text-sm">{s.excerpt}</p>
                        <p className="mt-4 text-xs text-[color:var(--cream-muted)]">— {s.author}</p>
                    </article>
                ))}
            </section>

            <div className="mt-32">
                <TeaserSlot
                    source="community-slot"
                    eyebrow="From the studio"
                    title="A first look at the series."
                    subtitle="The community we've built in-person is going on-screen. Watch the trailer for the debut."
                    cta="Watch the trailer"
                />
            </div>
        </main>
    );
}
